<template>
  <CustomPage title="我的店铺访客" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="flex justify-between text-xs mx-3 mb-3"
        style="color: #666666"
      >
        <div class="flex">
          <div
            class="rounded-full px-2"
            @click="activeTab = 0"
            :class="activeTab === 0 ? 'active' : ''"
          >
            今日
          </div>
          <!-- <div
          class="rounded-full px-2"
          @click="activeTab = 1"
          :class="activeTab === 1 ? 'active' : ''"
        >
          昨日
        </div> -->
          <div
            class="rounded-full px-2 ml-3"
            @click="activeTab = 2"
            :class="activeTab === 2 ? 'active' : ''"
          >
            近7日
          </div>
          <!-- <div
          class="rounded-full px-2"
          @click="activeTab = 3"
          :class="activeTab === 3 ? 'active' : ''"
        >
          近30日
        </div> -->
        </div>
        <Popover
          :offset="[-30, 0]"
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
        >
          <template #reference>
            <div :class="activeTab === 5 ? 'font-semibold' : ''">
              {{ selectedAction
              }}<Icon class="transform rotate-90" name="play" color="#E82035" />
            </div>
          </template>
        </Popover>
      </div>
      <List
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getData"
      >
        <div
          v-for="i in data"
          :key="i"
          class="flex items-center van-hairline--bottom p-3"
        >
          <!-- @click="
            $router.push({ name: 'StoreVisitorDetail', params: { id: i } })
          " -->
          <div class="mr-2" style="height: 34px; width: 34px">
            <img
              class="w-full h-full rounded-full"
              :src="i.imgUrl || require('@/assets/setting/avatar.png')"
            />
          </div>
          <div class="flex-grow">
            <div class="flex">
              <span class="text-xs mr-1">{{ i.name }}</span>
              <!-- <span class="text-xxs text-red mr-1">联系ta</span
              ><img src="@/assets/store/联系ta.svg" alt="" /> -->
            </div>
            <div class="text-xs" style="color: #aeaeae">
              {{ i.createTime }}
            </div>
          </div>
          <!-- <Icon name="arrow" /> -->
        </div>
      </List>

      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import { Popover, Icon, List } from 'vant'
import { getVisitorAccessLog } from '../webApi'
export default {
  components: { CustomPage, CustomView, Popover, Icon, List },
  created() {},
  data() {
    return {
      activeTab: 0,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      currentYear: this.dayjs().year(),
      currentMonth: this.dayjs().month() + 1,
      selectedAction: this.dayjs().format('YYYY-MM'),
      data: [],
      page: 0,
      size: 10,
      loading: false,
      finished: false,
    }
  },
  methods: {
    getData() {
      let params = { page: this.page, size: this.size }
      switch (this.activeTab) {
        case 0:
          params.dateType = 'today'
          break

        case 2:
          params.dateType = 'recentWeek'

          break

        case 5:
          params.dateType = 'certainMonth'
          params.parameter = this.selectedAction

          break

        default:
          break
      }
      getVisitorAccessLog(params).then(({ data }) => {
        this.data = this.data.concat(data.content)

        this.page++
        this.loading = false
        if (data.totalElements <= this.data.length) {
          this.finished = true
        }
      })
    },
    onSelect(action) {
      this.activeTab = 5
      this.selectedAction = action.text
      this.page = 0
      this.data = []
      this.loading = true
      this.finished = false
      this.getData()
    },
  },
  computed: {
    actions() {
      let temp = []
      for (let i = 0; i < 12; i++) {
        if (this.currentMonth > i) {
          temp.push({
            text: this.dayjs(
              this.currentYear + '-' + (this.currentMonth - i)
            ).format('YYYY-MM'),
          })
        } else {
          temp.push({
            text: this.dayjs(
              this.currentYear - 1 + '-' + (this.currentMonth - i + 12)
            ).format('YYYY-MM'),
          })
        }
      }

      return temp
    },
  },
  watch: {
    activeTab(val) {
      if (val !== 5) {
        this.page = 0
        this.data = []
        this.loading = true
        this.finished = false
        this.getData()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}
</style>
